let React = require('react');
import { Link, Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import { GenericSimpleButton, GenericSimpleIconButton } from 'com-gyf-webcore-userinterfacecomponents';

let Footer = React.createClass({
    render: function () {
        if (this.props.data.redirectToNuevaSolicitudConfirmacion)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudCuenta", "ROUTE_TO_CONFIRMACION")} push />

        let btn;
        if (this.props.data.esSolicitudGuardada) {
            btn = <div className="col-md-3"><GenericSimpleButton text="Guardar Borrador" buttonClass="btn btn-secondary disabled" /></div>
        }
        else {
            btn = <div className="col-md-3">
                <GenericSimpleButton text="Guardar Borrador" buttonClass="btn btn-secondary"
                    onClick={() => this.props.guardarSolicitudBorrador()} />
            </div>
        }
        return (
            <div className="row top-separator-xs">
                {(this.props.data.permisos.components.BotonesAnteriorSiguiente.Active == true) &&
                    <div className="col-md-2">
                    <Link to={ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_CUENTA")} className="btn btn-secondary">&#60; Anterior</Link>
                    </div>}
                <div className="col-md-2">
                    <Link to={ProcessManager.GetNextStep("NuevaSolicitudTarjeta", "ROUTE_TO_VISTA_CLIENTE")} className="btn btn-secondary">Cancelar</Link>
                </div>
                <div className="col-md-3">
                </div>
                {(this.props.data.permisos.components.BotonGuardarBorrador.Active == true) &&
                    btn}
                {(this.props.data.permisos.components.BotonesAnteriorSiguiente.Active == true) &&
                    <div className="col-md-2">
                    <GenericSimpleButton text="Siguiente > " buttonClass="btn btn-cta" onClick={() => this.routeToNuevaSolicitudConfirmacion(this.props.data.tarjetas)} />
                    </div>}
            </div>
        );
    },

    routeToNuevaSolicitudConfirmacion() {
        this.props.routeToNuevaSolicitudConfirmacion();
    },

    cancelClick: function () {
        $("#discardChangesModal").modal();
    },

    guardarSolicitudBorrador: function () {
        //NewRequestCreateCardActions.guardarSolicitudBorrador(this.props.data.request);
        this.props.guardarSolicitudBorrador(this.props.data.request);
    }
});

export default Footer